import { inflate } from 'zlib';

/**
 * @param obj
 * @param diff (input from dynamodb-stream-diff), diff.diffList
 */
export const objDiff = (obj, diff) => {
  if (!diff || !diff.length) return obj;

  const updatedObj = JSON.parse(JSON.stringify(obj));

  diff.forEach(({ path, diff, newVal }) => {
    const [ initial, ...keys ] = path.split('.');

    if (!keys || !keys.length) {
      if (diff === 'deleted' && updatedObj.hasOwnProperty(initial)) {
        // console.log(`deleting prop ${initial}`);
        delete updatedObj[initial];
      } else {
        // console.log(`setting ${initial} to ${newVal}`);
        updatedObj[initial] = newVal;
      }
    } else {
      let element = updatedObj[initial];

      for (let i = 0; i < keys.length; i++) {
        // console.log(`i = ${i}, current element: ${keys[i]}`);
        if (i === keys.length - 1) {
          if (diff === 'deleted' && element.hasOwnProperty(keys[i])) {
            // console.log(`deleting prop ${keys[i]}`);
            delete element[keys[i]];
          } else {
            // console.log(`setting ${keys[i]} to ${newVal}`);
            element[keys[i]] = newVal;
          }
        } else {
          element = element[keys[i]];
        }
      }
    }
  });

  return updatedObj;
};

export const unzip = payload => {
  return new Promise((resolve, reject) => {
    if (!payload || !payload.gzip) {
      console.log(`Nothing to unzip`);
      resolve(payload);
    } else {
      const options = { windowBits: 15 };

      inflate(new Buffer(payload.body, 'base64'), options, (err, unzippedBody) => {
        if (err) {
          console.log(`Error during unzip`);
          console.log(err);
          reject(err);
        } else {
          const updatedPayload = Object.assign({}, payload, {
            body: JSON.parse(unzippedBody.toString())
          });
          resolve(updatedPayload);
        }
      });
    }
  });
};


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/ngrx/utility.ts